/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Features_DescriptionInputs */

const en_seo_features_description = /** @type {(inputs: Seo_Features_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online booking page, clients, training and diet plans, passes and payments: everything a trainer runs the business with, in one app.`)
};

const pl_seo_features_description = /** @type {(inputs: Seo_Features_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strona z rezerwacjami online, podopieczni, plany treningowe i dietetyczne, karnety i płatności: wszystko, czym trener prowadzi biznes, w jednej aplikacji.`)
};

/**
* | output |
* | --- |
* | "Online booking page, clients, training and diet plans, passes and payments: everything a trainer runs the business with, in one app." |
*
* @param {Seo_Features_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const seo_features_description = /** @type {((inputs?: Seo_Features_DescriptionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Features_DescriptionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_seo_features_description(inputs)
	return en_seo_features_description(inputs)
});